import { axios } from 'lib/axios';

export const resetPassword = (token, data) => {
  return axios.post(`/auth/reset-password/${token}`, data);
};
